<template>
  <v-container v-if="lessons != null" class="px-0">
    <table class="ma-10">
      <thead>
        <tr>
          <th rowspan="2">№</th>
          <th
            style="width: 20%"
            rowspan="2"
            v-for="(hln, hlnIndex) in headLectureNames1"
            :key="'hlnIndex1' + hlnIndex"
          >
            {{ hln }}
          </th>
          <th
            style="width: 10%"
            class="text-center"
            :colspan="_getSemesterMonths().length"
            v-for="(hln, hlnIndex) in headLectureNames2"
            :key="'hlnIndex2' + hlnIndex"
          >
            {{ hln }}
          </th>
          <th colspan="4">Бусад</th>
          <th colspan="2">Дүн</th>
          <th colspan="2">Хянасан СМ</th>
        </tr>

        <tr>
          <td
            v-for="(mm, mmIndex) in _getSemesterMonths()"
            :key="'mmIndexA' + mmIndex"
          >
            {{ mm.month }}
          </td>
          <td
            v-for="(mm, mmIndex) in _getSemesterMonths()"
            :key="'mmIndexB' + mmIndex"
          >
            {{ mm.month }}
          </td>
          <td
            v-for="(mm, mmIndex) in _getSemesterMonths()"
            :key="'mmIndexC' + mmIndex"
          >
            {{ mm.month }}
          </td>
          <td
            v-for="(mm, mmIndex) in _getSemesterMonths()"
            :key="'mmIndexD' + mmIndex"
          >
            {{ mm.month }}
          </td>
          <td>Шалгалтын комисс</td>
          <td>Төгсөлтийн ажил</td>
          <td>Дипломын ажил</td>
          <td>Дипломын төсөлд шүүмж</td>
          <td><strong>Цаг</strong></td>
          <td><strong>Багц цаг</strong></td>
          <td>Тооцсон кр</td>
          <td>Гарын үсэг</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(lesson, index) in lessons" v-bind:key="'lesson-' + index">
          <td>{{ lesson.index }}</td>
          <td v-if="lesson.lessonStandard">
            {{ lesson.lessonStandard.name }}
          </td>
          <td v-else>{{ lesson.name }}</td>
          <td>3</td>

          <td class="noborder">
            <tr
              v-for="(cgroup, cgroupIndex) in lesson.lessonGroups"
              :key="'lessonGroups-' + cgroupIndex"
            >
              <td
                v-if="cgroup.classGroups"
                @click="_getTopicAllTime(cgroup)"
                class="pa-0 ma-0 noborder"
              >
                {{ cgroup.name }}
                <span v-if="cgroup.teachedGroups"
                  >- {{ cgroup.teachedGroups.length }}</span
                >
              </td>
              <td v-else>-</td>
            </tr>
          </td>

          <td class="noborder" style="">
            <tr
              v-for="(cgroup, cgroupIndex) in lesson.lessonGroups"
              :key="'lessonGroups-' + cgroupIndex"
            >
              <div
                style="width: 100% !important; border: 1px solid black"
                v-if="cgroup.classGroups"
                @click="_getTopicAllTime(cgroup)"
                class="pa-0 ma-0"
              >
                101
                <span v-if="cgroup.teachedGroups"
                  >- {{ cgroup.teachedGroups.length }}</span
                >
              </div>
              <td v-else>-</td>
            </tr>
          </td>

          <template v-if="lesson.xlecturePerGroup == false">
            <td
              v-for="(mm, mmIndex) in _getSemesterMonths()"
              :key="'lectureData' + mmIndex"
            >
              ddd
            </td>
          </template>
          <template v-else>
            <td :colspan="_getSemesterMonths().length">
              <tr
                v-for="(cgroup, cgroupIndex) in lesson.lectureLessonGroups"
                :key="'lectureLessonGroups-' + cgroupIndex"
              >
                <td>
                  {{ _getSemesterMonths().length }}
                </td>
              </tr>
            </td>
          </template>

          <template v-if="lesson.xseminarPerGroup == false">
            <td
              v-for="(ddate, mmIndex) in _getSemesterMonths()"
              :key="'seminarData1' + mmIndex"
            >
              {{ _getCredit(lesson, ddate.month, "seminars") }}
            </td>
          </template>
          <template v-else>
            <td
              v-for="(ddate, mmIndex) in _getSemesterMonths()"
              :key="'seminarData2' + mmIndex"
            >
              <tr
                v-for="(cgroup, cgroupIndex) in lesson.seminarLessonGroups"
                :key="'seminarLessonGroups-' + cgroupIndex"
              >
                <td :rowspan="cgroup.lessonGroups.length">
                  {{
                    _getCreditPerGroup(cgroup, lesson, ddate.month, "seminars")
                  }}
                </td>
              </tr>

              <!-- <tr
                v-for="(cgroup, cgroupIndex) in _getRestList(lesson)"
                :key="'seminarGroups2-' + cgroupIndex"
              >
                <td style="color: black">{{  lesson.lessonGroups.length - lesson.seminarLessonGroups.length}}</td>
              </tr> -->
            </td>
          </template>
        </tr>
      </tbody>
    </table>
    <v-card icon="mdi-clipboard-text" icon-small color="accent">
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">ID</th>
            <th class="primary--text">Xичээлийн нэр</th>
            <th class="primary--text">Код</th>
            <th class="primary--text">Кредит</th>
            <th class="primary--text">Цагууд</th>
            <th class="primary--text">Багш</th>
            <th class="primary--text">Анги, курс</th>
            <th class="primary--text">Анги, курс2</th>
            <th
              v-for="(mm, mmIndex) in _getSemesterMonths()"
              :key="'mmIndexHead' + mmIndex"
            >
              {{ mm.month }}
            </th>
          </tr>
        </thead>

        <template v-if="lessons">
          <tbody>
            <tr v-for="(item, index) in lessons" v-bind:key="index">
              <td>{{ item.index }}</td>
              <td v-if="item.lessonStandard">
                {{ item.lessonStandard.name }}
              </td>
              <td v-else>{{ item.name }}</td>
              <td>
                <span v-if="item.lessonStandard2">{{
                  item.lessonStandard2.code
                }}</span>
              </td>
              <td>
                <span v-if="item.lessonStandard2">{{
                  item.lessonStandard2.credit
                }}</span>
              </td>

              <td v-if="item.lessonStandard2">
                {{ item.lessonStandard2.creditLecture }}:{{
                  item.lessonStandard2.creditSeminar
                }}:{{ item.lessonStandard2.creditHomework }}
              </td>
              <td v-else>::</td>
              <td>
                <span v-if="item.teacherFirstName">{{
                  item.teacherFirstName
                }}</span>
                <span v-else class="red--text">Багш сонгоогүй</span>
              </td>
              <td>
                <tr
                  v-for="(cgroup, cgroupIndex) in item.lessonGroups"
                  :key="'lessonGroups-' + cgroupIndex"
                >
                  <td v-if="cgroup.classGroups">
                    <span
                      v-for="(lgroup, lgroupIndex) in cgroup.classGroups"
                      :key="'lgroupIndex-' + lgroupIndex"
                      >{{ lgroup.classGroupShortName }}-{{
                        lgroup.classNumber
                      }},
                    </span>
                  </td>
                  <td v-else>-</td>
                </tr>
              </td>
              <td>
                <tr
                  v-for="(cgroup, cgroupIndex) in item.lessonGroups"
                  :key="'lessonGroups-' + cgroupIndex"
                >
                  <td
                    v-if="cgroup.classGroups"
                    @click="_getTopicAllTime(cgroup)"
                  >
                    {{ cgroup.name }}
                    <span v-if="cgroup.teachedGroups"
                      >- {{ cgroup.teachedGroups.length }}</span
                    >
                  </td>
                  <td v-else>-</td>
                </tr>
              </td>
              <td
                v-for="(xxx, ttypeIndex) in ['lecture', 'seminar', 'homework']"
                :key="ttypeIndex"
              >
                <tr
                  v-for="(cgroup, cgroupIndex) in item.lessonGroups"
                  :key="'lessonGroups-' + cgroupIndex"
                >
                  <td v-if="cgroup.teachedTopics">
                    <!-- <span
                          v-for="(tgroup, tgroupIndex) in cgroup.teachedTopics"
                          :key="'tgroupIndex-' + tgroupIndex"
                          >{{ tgroup.teachedTime }}</span
                        > -->
                    {{ _getTopicAllTime(cgroup, xxx) }}
                  </td>
                  <td v-else>-</td>
                </tr>
              </td>
              <td
                v-for="(mm, mmIndex) in _getSemesterMonths()"
                :key="'mmIndex' + mmIndex"
              >
                {{ mm.month }}
              </td>
            </tr>
          </tbody>
        </template>
        <template v-else>
          <h1>xxx</h1>
        </template>
      </v-simple-table>
    </v-card>
  </v-container>
  <v-container v-else class="px-0">
    <v-card flat height="200">
      <h3 class="text-center accent--text">
        Танд одоогоор ямар нэгэн xичээл xуваарьлагдаагүй байна!
      </h3>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
const fb = require("../../firebaseConfig.js");
export default {
  name: "RegularTablesView",
  data: () => ({
    headLectureNames1: [
      "Хичээлийн нэр",
      "Хичээлийн багц цаг",
      "Анги курс",
      "Оюутны тоо",
    ],
    headLectureNames2: [
      "Лекц",
      "Семинар",
      "Лаборатори",
      "Дадлага",
      // "Бусад",
      // "Дүн",
      // "Хянасан",
      // "СМ",
    ],
    willSearch: false,
    colWidth: 12,
    detailDialog: false,

    currentSelectedLessonStandart: {},

    messageNotification: null,

    lessonstandards: null,
  }),
  components: {},
  props: {
    lessons: {
      required: true,
      type: Array,
    },
    schoolPath: {
      required: true,
      type: String,
    },
  },
  watch: {},
  computed: {
    ...mapState(["userProfile", "currentUser", "xxschool"]),
    filteredLessonstandards() {
      if (this.selectedDepartment != null) {
        return this.lessonstandards.filter(
          (item) =>
            item.department &&
            item.department.ref.path === this.selectedDepartment.ref.path
        );
      } else {
        return this.lessonstandards;
      }
    },
  },
  created() {
    this._setupp();
  },

  methods: {
    _getCredit(lesson, teachedMonth, ctype) {
      //ddd_getCredit(cgroup, lesson, ddate.month, "seminars")
      var allTeachedTsag = 0;
      if (lesson[ctype]) {
        for (var topic of lesson[ctype]) {
          if (topic.teachedDate && topic.teachedMonth) {
            if (topic.teachedMonth == teachedMonth)
              allTeachedTsag = allTeachedTsag + topic.tsag;
          }
        }
      }
      return allTeachedTsag;
    },
    _getCreditPerGroup(cgroup, lesson, teachedMonth, ctype) {
      var allTeachedTsag = 0;
      if (lesson[ctype]) {
        for (var topic of lesson[ctype]) {
          if (topic.teachedGroups) {
            for (var teachedGroup of topic.teachedGroups) {
              if (teachedGroup.classGroupRef.path == cgroup.ref.path) {
                if (teachedGroup.teachedMonth == teachedMonth)
                  allTeachedTsag = allTeachedTsag + topic.tsag;
              }
            }
          }
        }
      }
      return allTeachedTsag;
    },
    _getRestList(item) {
      var list = [];
      if (
        item.lessonGroups &&
        item.lessonGroups.length &&
        item.seminarLessonGroups &&
        item.seminarLessonGroups.length
      )
        list = Array.from(
          Array(
            item.lessonGroups.length - item.seminarLessonGroups.length
          ).keys()
        );
      return list;
    },
    _getSemesterMonths() {
      var list = [];
      for (
        var year = this.$attrs.semester.startYear;
        year <= this.$attrs.semester.endYear;
        year++
      ) {
        if (this.$attrs.semester.startYear == this.$attrs.semester.endYear) {
          console.log(
            "YES",
            this.$attrs.semester.startMonth,
            this.$attrs.semester.endMonth
          );
          for (
            var month = this.$attrs.semester.startMonth;
            month <= this.$attrs.semester.endMonth;
            month++
          ) {
            list.push({ year: year, month: month });
          }
        } else {
          if (year == this.$attrs.semester.startYear) {
            for (
              var month = this.$attrs.semester.startMonth;
              month <= 12;
              month++
            ) {
              list.push({ year: year, month: month });
            }
          } else if (year == this.$attrs.semester.endYear) {
            for (
              var month = 1;
              month <= this.$attrs.semester.endMonth;
              month++
            ) {
              list.push({ year: year, month: month });
            }
          } else {
            for (var month = 1; month <= 12; month++) {
              list.push({ year: year, month: month });
            }
          }
        }
      }
      console.log(list);
      return list;
    },
    _getTopicAllTime(cgroup, value) {
      var x = 0;
      for (var tt of cgroup.teachedTopics) {
        if (tt.teachedTime && tt.ctype == value) x = x + tt.teachedTime;
      }
      return x;
    },
    _tmp(cgroup) {
      console.log(cgroup);
    },
    _detail(item, index) {
      // this.editedItem = item;
      // this.detailDialog = true;
      console.log(item);
      const routeData = this.$router.push({
        name: "TeacherLessonDetail",
        params: {
          // schoolId: this.school.id,
          // lessonId: item.id,
          xpath: item.ref.path,
        },
      });
      //window.open(routeData.href, "_blank");
    },

    _setupp() {
      fb.db
        .collection(this.schoolPath + "/lessons-standards")
        .orderBy("name", "asc")
        .onSnapshot((querySnapshot) => {
          this.lessonstandards = [];
          querySnapshot.forEach((doc) => {
            let item = doc.data();
            item.id = doc.id;
            item.ref = doc.ref;
            this.lessonstandards.push(item);
          });
        });
    },

    _getPath() {
      return this.schoolPath + "/lessons";
    },
  },
};
</script>
 <style>
table,
th,
td {
  /* border: 1px solid black; */
  border-collapse: collapse;
}
table {
  border-spacing: 0px;
}
.noborder {
  /* border-top: none;
  border-left: none;
  border-right: none; */
}
</style>